import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import Layout from '../components/Layout';

const HomePage = lazy(() => import('../pages/home/page'));
const QuienesSomosPage = lazy(() => import('../pages/quienes-somos/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const PorQueRenovaPage = lazy(() => import('../pages/por-que-renova/page'));
const TestimoniosPage = lazy(() => import('../pages/testimonios/page'));
const TurnosPage = lazy(() => import('../pages/turnos/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const PoliticaDePrivacidadPage = lazy(() => import('../pages/politica-de-privacidad/page'));
const TerminosYServiciosPage = lazy(() => import('../pages/terminos-y-servicios/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'quienes-somos',
        element: <QuienesSomosPage />,
      },
      {
        path: 'especialidades-medicas',
        element: <ServiciosPage />,
      },
      {
        path: 'por-que-renova',
        element: <PorQueRenovaPage />,
      },
      {
        path: 'testimonios',
        element: <TestimoniosPage />,
      },
      {
        path: 'turnos',
        element: <TurnosPage />,
      },
      {
        path: 'contacto',
        element: <ContactoPage />,
      },
      {
        path: 'politica-de-privacidad',
        element: <PoliticaDePrivacidadPage />,
      },
      {
        path: 'terminos-y-servicios',
        element: <TerminosYServiciosPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
];

export default routes;
